import React, {useContext} from 'react'
import clsx from 'clsx'
import {KTIcon} from '@/_metronic/helpers'
import {Card} from '@/components/Card'
import {CustomerContext} from '../../CustomerContext'
import {useIntl} from 'react-intl'

import {CustomerStatus} from '../../../core/_models'

const StatusesCard = () => {
  const {customer} = useContext(CustomerContext)
  const intl = useIntl()

  return (
    <Card
      title="Status Timeline"
      collapsable={false}
      className="card mb-2"
    >
      <div className="timeline">
        {(customer?.statuses || []).map((s: CustomerStatus, index: number) => (
          <div key={`state-${index}`} className='timeline-item'>
            <div className='timeline-line w-40px'></div>

            <div className='timeline-icon symbol symbol-circle symbol-40px'>
              <div className='symbol-label'>
                <i className={clsx('fa fa-genderless fs-1 text-success', {
                  'text-info': s.status === 'PENDING_VALIDATION',
                  'text-success': s.status === 'VALIDATED',
                  'text-warning': s.status === 'DELETED',
                  'text-danger': s.status === 'LOCKED',
                })}></i>
              </div>
            </div>

            <div className='timeline-content mb-5'>
              <div className='overflow-auto pe-3'>
                <div className='fs-5 fw-bold'>
                  {intl.formatMessage({id: `CUSTOMER_STATUS_${s.status}`})}
                  {s.reason && (
                    <span title={s.reason}>
                      <KTIcon iconName="information-2" className='fs-3 text-primary ms-2' />
                    </span>
                  )}
                </div>

                <div className='d-flex align-items-center fs-6'>
                  <div className='text-muted me-2 fs-7'>
                    {intl.formatDate(s.date, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </Card>
  )
}

export {StatusesCard}
